/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_BIG_smoothing': {
    width: 64,
    height: 51,
    viewBox: '0 0 64 51',
    data: '<path pid="0" d="M0 26h8l8-16 8 16h8L44 2l12 24h8M0 34h3.777a6.833 6.833 0 0 0 6.112-3.777c2.518-5.036 9.704-5.036 12.223 0l.1.2a6.472 6.472 0 0 0 11.577 0l3.056-6.112c2.948-5.897 11.362-5.897 14.31 0l2.634 5.267A8 8 0 0 0 60.944 34H64M0 42h.51c2.295 0 4.559-.534 6.612-1.56l2.92-1.46a9.923 9.923 0 0 1 10.972 1.407 9.923 9.923 0 0 0 13.55-.451l1.697-1.697a12.488 12.488 0 0 1 15.757-1.56l4.654 3.102A13.211 13.211 0 0 0 64 42M0 50h64"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_BIG_smoothing.js